import { Alert } from "./Alert"

export const ErrorDescription: React.FC = ({ children }) => <Alert type="error">{children}</Alert>
